<div [formGroup]="formGroup">
  <yc-typeahead
    name="searchTerm"
    [getDisplay]="getDisplay"
    [fetchData]="debounce.exec"
    [placeholder]="placeholder || ''"
    [label]="'common:lblOrganization' | ycI18n: 'Organization'"
    [srOnlyLabel]="true"
    [showNoResults]="true"
    [searchIcon]="true"
    (onChange)="orgSelected($event)">
    <ng-container *ycTypeaheadTemplate="let item = item;">
      <div class="d-flex flex-row" #row>
        <div class="p-2">
          <img [src]="{
            iconURL: item.document?.iconURL,
            classification: item.document?.classification
          } | getOrgIcon">
        </div>
        <div class="mr-auto ps-2 pt-2">
          <!-- Name -->
          <ng-container>
            <div class="name-wrap">
              {{ item.document.displayName || item.document.name || item.document.remittanceName }}
            </div>
          </ng-container>
          <!-- Address -->
          <small class="d-block">
            <ng-container *ngIf="!item.document.addressString">
              {{ item.document | gcSearchNppAddress }}
            </ng-container>
            <ng-container *ngIf="item.document.addressString">
              {{ item.document.addressString }}
            </ng-container>
          </small>
          <!-- Registration ID -->
          <small class="d-block">
            {{ item.document.registrationId | ein }}
          </small>
          <!-- Parent Info -->
          <small *ngIf="item.document.parentName"
            class="d-block">
            <yc-i18n
              key="nonprofit:lblParentTagLine"
              defaultValue="This organization is a chapter/affiliate of ">
            </yc-i18n>
            {{ item.document.parentName }} ({{ item.document.registrationId | ein }})
          </small>
        </div>
      </div>
    </ng-container>
  </yc-typeahead>
</div>

